import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import OfferPage from "./pages/OfferPage";
import BookingPage from "./pages/BookingPage";
import ContactPage from "./pages/ContactPage";
import { PrivacyPage, TermsPage } from "./pages/LegalPages";
import Analytics from "./components/Analytics";

// Global SVG filter that turns the black background of the logo PNG transparent.
// It maps the blue channel to alpha so pure black (0,0,0) becomes transparent
// while the blue logo strokes remain fully visible.
const GlobalSVGFilters = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <filter id="logo-knockout-black" colorInterpolationFilters="sRGB">
        <feColorMatrix
          type="matrix"
          values="1 0 0 0 0
                  0 1 0 0 0
                  0 0 1 0 0
                  0 0 1 0 0"
        />
      </filter>
    </defs>
  </svg>
);

function App() {
  return (
    <div className="App">
      <Analytics />
      <GlobalSVGFilters />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/offer" element={<OfferPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
